import { createPropertySelectors } from '@ngxs/store'
import { DataTableState, DataTableStateModel } from './data-table.state'

export class DataTableStateSelectors {
  static slices = createPropertySelectors<DataTableStateModel>(DataTableState)
}
